import * as THREE from "three";

import { computeCurvatureDirections } from "../../geometry/computeCurvatureDirections";

const TorusKnotModel = {
  id: "torus-knot",

  name: "Torus Knot",

  type: "procedural",

  createGeometry() {
    const geometry = new THREE.TorusKnotGeometry(1.15, 0.38, 256, 64);

    return computeCurvatureDirections(geometry);
  },

  transform: {
    scale: 1.0,

    rotation: [0.1, -0.4, 0],
  },

  capabilities: {
    normals: true,
    uv: true,
    tangents: false,
  },
};

export default TorusKnotModel;
